import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  reviewCard: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    padding: theme.spacing(2, 2.5),
    backgroundColor: '#FFFFFF',
    minWidth: 0,
    overflow: 'hidden',
  },
  reviewHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  reviewerAvatar: {
    width: 40,
    height: 40,
    fontSize: '0.875rem',
    fontWeight: 400,
    color: '#172024',
    backgroundColor: '#EBF0F2',
    textTransform: 'uppercase',
    flexShrink: 0,
  },
  reviewerMeta: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  reviewerName: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#00205B',
  },
  reviewDate: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  reviewRating: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    flexShrink: 0,
    marginLeft: 'auto',
    '& .MuiRating-root .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
  },
  starButton: {
    padding: theme.spacing(0, 0.25),
    marginLeft: -3,
    fontSize: '1rem',
    '&:first-child': {
      marginLeft: 0,
    },
  },
  reviewTextWrapper: {
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
  },
  reviewText: {
    fontSize: '0.9375rem',
    lineHeight: 1.5,
    color: theme.palette.text.primary,
    maxWidth: '100%',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  reviewFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1.5),
  },
  reviewActions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    minWidth: 0,
  },
  reviewAction: {
    color: '#0053FF',
    padding: 0,
    minWidth: 0,
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'none',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#0053FF',
    },
  },
  copyButton: {
    flexShrink: 0,
    width: 32,
    height: 32,
    padding: theme.spacing(0.75),
    border: '1px solid #E0E0E0',
    borderRadius: 8,
    color: '#172024',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      color: '#0053FF',
      borderColor: '#BDBDBD',
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  },
  copyIcon: {
    fontSize: 18,
  },
}))

export default useStyles
